"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Programs = /*#__PURE__*/function () {
  function Programs(client) {
    (0, _classCallCheck2["default"])(this, Programs);
    this.client = client;
    this.resourceUrl = '/programs';
  }

  (0, _createClass2["default"])(Programs, [{
    key: "getPrograms",
    value: function getPrograms(id, limit) {
      var url = "".concat(this.resourceUrl, "?id=").concat(id);

      if (limit) {
        url = url + "&limit=".concat(limit);
      }

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getMainPrograms",
    value: function getMainPrograms() {
      var url = "".concat(this.resourceUrl, "/list");

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getModuleById",
    value: function getModuleById(id) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(id), args);
    }
  }, {
    key: "getModuleFirstMedia",
    value: function getModuleFirstMedia(id, journeyId, sequenceId, sessionId) {
      var url = "".concat(this.resourceUrl, "/").concat(id, "/first");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      if (sessionId) {
        url += "?sessionId=".concat(sessionId);
      }

      for (var _len4 = arguments.length, args = new Array(_len4 > 4 ? _len4 - 4 : 0), _key4 = 4; _key4 < _len4; _key4++) {
        args[_key4 - 4] = arguments[_key4];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getMediaById",
    value: function getMediaById(moduleId, mediaId, journeyId, sequenceId, sessionId) {
      var url = "".concat(this.resourceUrl, "/").concat(moduleId, "/media/").concat(mediaId);

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      if (sessionId) {
        url += "?sessionId=".concat(sessionId);
      }

      for (var _len5 = arguments.length, args = new Array(_len5 > 5 ? _len5 - 5 : 0), _key5 = 5; _key5 < _len5; _key5++) {
        args[_key5 - 5] = arguments[_key5];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getNextMedia",
    value: function getNextMedia(categoryId, mediaId, journeyId, sequenceId) {
      var url = "".concat(this.resourceUrl, "/").concat(categoryId, "/media/").concat(mediaId, "/next");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      for (var _len6 = arguments.length, args = new Array(_len6 > 4 ? _len6 - 4 : 0), _key6 = 4; _key6 < _len6; _key6++) {
        args[_key6 - 4] = arguments[_key6];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getPreviousMedia",
    value: function getPreviousMedia(categoryId, mediaId, journeyId, sequenceId) {
      var url = "".concat(this.resourceUrl, "/").concat(categoryId, "/media/").concat(mediaId, "/previous");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      for (var _len7 = arguments.length, args = new Array(_len7 > 4 ? _len7 - 4 : 0), _key7 = 4; _key7 < _len7; _key7++) {
        args[_key7 - 4] = arguments[_key7];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "toggleFavorite",
    value: function toggleFavorite(data, id) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(id, "/favorite"), data, args);
    }
  }, {
    key: "updateMediaStatus",
    value: function updateMediaStatus(data, categoryId, mediaId) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 3 ? _len9 - 3 : 0), _key9 = 3; _key9 < _len9; _key9++) {
        args[_key9 - 3] = arguments[_key9];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(categoryId, "/media/").concat(mediaId, "/status"), data, args);
    }
  }, {
    key: "getFavorites",
    value: function getFavorites() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      return this.client.get("".concat(this.resourceUrl, "/favorites"), args);
    }
  }, {
    key: "getCurrentStatus",
    value: function getCurrentStatus() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      return this.client.get("".concat(this.resourceUrl, "/current-status"), args);
    }
  }, {
    key: "getURLForSkillPDF",
    value: function getURLForSkillPDF(moduleId, mediaId, sessionId) {
      var url = "".concat(this.resourceUrl, "/").concat(moduleId, "/media/").concat(mediaId, "/url");

      if (sessionId) {
        url += "?sessionId=".concat(sessionId);
      }

      for (var _len12 = arguments.length, args = new Array(_len12 > 3 ? _len12 - 3 : 0), _key12 = 3; _key12 < _len12; _key12++) {
        args[_key12 - 3] = arguments[_key12];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getPracticalAudioByFilename",
    value: function getPracticalAudioByFilename(moduleId, fileName) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 2 ? _len13 - 2 : 0), _key13 = 2; _key13 < _len13; _key13++) {
        args[_key13 - 2] = arguments[_key13];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(moduleId, "/practical-audio?fileName=").concat(fileName), args);
    }
  }, {
    key: "getPoeticAudio",
    value: function getPoeticAudio(moduleId, fileName) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        args[_key14 - 2] = arguments[_key14];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(moduleId, "/poetic-audio?fileName=").concat(fileName), args);
    }
  }, {
    key: "favoriteModuleAudio",
    value: function favoriteModuleAudio(categoryId, mediaId, data) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 3 ? _len15 - 3 : 0), _key15 = 3; _key15 < _len15; _key15++) {
        args[_key15 - 3] = arguments[_key15];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(categoryId, "/media/").concat(mediaId, "/favourite"), data, args);
    }
  }, {
    key: "getModuleBasicDetailsById",
    value: function getModuleBasicDetailsById(id) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      for (var _len16 = arguments.length, args = new Array(_len16 > 2 ? _len16 - 2 : 0), _key16 = 2; _key16 < _len16; _key16++) {
        args[_key16 - 2] = arguments[_key16];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(id, "/basic-data"), data, args);
    }
  }, {
    key: "getAdjoining",
    value: function getAdjoining(moduleId) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(moduleId, "/adjoining?onlyIds=true"), args);
    }
  }]);
  return Programs;
}();

exports["default"] = Programs;